export enum LauncherState {
  Settings = 'Settings',
  ChooseHost = 'ChooseHost',
  HostCredentials = 'HostCredentials',
  BillingPeriod = 'BillingPeriod',
  Review = 'Review',
  Launching = 'Launching',
}
